import React, { useReducer, useCallback, useMemo } from 'react';
import { node } from 'prop-types';

import CoachmarkStock from 'Component/StockAction/CoachmarkStock';
import reducers, { SET_COACHMARK_REFS } from './reducers';
// add this style temporarily to fix the issue style was not export properly from ajaib/lib
// ref: https://github.com/vitejs/vite/discussions/2657
import './style.css';

export const CoachmarkContext = React.createContext();

const CoachmarkProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducers, {
    coachmarkRefs: {
      coachmarkStock: {
        stockPopupBuy: null,
        tickerTabs: null,
        bottomPanel: null,
      },
    },
  });

  const dispatchHelper = useCallback((type, payload) => {
    dispatch({ type, payload });
  }, []);

  const setCoachmarkRefs = useCallback((payload) => {
    dispatchHelper(SET_COACHMARK_REFS, payload);
  }, []);

  const valueProps = useMemo(
    () => ({
      ...state,
      setCoachmarkRefs,
    }),
    [setCoachmarkRefs, state]
  );

  return (
    <CoachmarkContext.Provider value={valueProps}>
      {children}
      <CoachmarkStock
        refs={{
          stockPopupBuy: state.coachmarkRefs.coachmarkStock.stockPopupBuy,
          tickerTabs: state.coachmarkRefs.coachmarkStock.tickerTabs,
          bottomPanel: state.coachmarkRefs.coachmarkStock.bottomPanel,
        }}
      />
    </CoachmarkContext.Provider>
  );
};

CoachmarkProvider.propTypes = {
  children: node.isRequired,
};

export default CoachmarkProvider;
